////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
/////////ASSETS/////////
import Actif from '../../../assets/icones/global/actif-item.svg'
import Inactif from '../../../assets/icones/global/cross-circle-red.svg'

//////STYLED//////
const UsersManagerEnableComponentWrapper = styled.div`
	text-align: center;
`
const UsersManagerEnableColor = styled.img`
	width: 20px;
	height: 20px;
	display: inline-block;
`
//////STYLED//////

const UsersManagerRoleComponent = (props) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<UsersManagerEnableComponentWrapper>
			{props.column?.useCustomSkeleton && props.row?.rowTableSkeleton ? (
				<Skeleton width={20} height={20} style={{ lineHeight: '20px', borderRadius: '20px' }} />
			) : (
				<UsersManagerEnableColor src={props.row.enabled ? Actif : Inactif} />
			)}
		</UsersManagerEnableComponentWrapper>
	)
}

UsersManagerRoleComponent.propTypes = {}

UsersManagerRoleComponent.defaultPropTypes = {}

export default UsersManagerRoleComponent
